<template>
  <div>
    <van-field  input-align="right" :required="true" right-icon="arrow" readonly clickable name="picker" :value="cargoHoldsNumbs" label="货舱数" placeholder="点击选择货舱数" @click="showPickerBtn"/>

    <van-field name="radio" label="有溢油探头" input-align="right" :required="true" :error-message="oilSpillProbeError">
      <template #input>
        <van-radio-group v-model="isOilSpillProbe" direction="horizontal" @change="handleOilSpillProbeChange">
          <van-radio name="Y">是</van-radio>
          <van-radio name="N">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="cargoHoldsNumbsList" @confirm="onConfirm" @cancel="showPicker = false"/>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import api from "@/fetch/api";

export default{
  props: {
    isRequire:{
      type:Boolean,
      default:true,
    },
    cargoHoldsNumbs:{
        type:String,
        default:"",
    },
  },
  data(){
    return {
      showPicker:false,
      cargoHoldsNumbsList:[],
      isOilSpillProbe: '', //是否有溢油探头
      oilSpillProbeError: "", // 错误提示信息
    }
  },
  created()
  {
    this.getCargoHoldsNumbs();
  },
  methods:{
    // 处理溢油探头选择变化
    handleOilSpillProbeChange(value) {
      this.isOilSpillProbe = value;
      this.validateOilSpillProbe();
      this.$emit("oilSpillProbeChange", value); // 新增：向父组件传递值
    },
    // 验证是否选择
    validateOilSpillProbe() {
      if (!this.isOilSpillProbe) {
        this.oilSpillProbeError = "请选择是否有溢油探头";
      } else {
        this.oilSpillProbeError = "";
      }
    },
    getCargoHoldsNumbs()
    {
      var that = this;
      var typeGroupName = "cargoHoldsNumbs";
      api.getTypeList(typeGroupName).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.success == true) {
          var result = resData.obj;
          var cargoHoldsNumbsList = [];
          console.log("result",result)
          result.forEach((item) => {
            if(item.typename) cargoHoldsNumbsList.push(item.typename);
          });
          that.cargoHoldsNumbsList = cargoHoldsNumbsList;
        } else {
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
      });
    },
    showPickerBtn()
    {
      this.showPicker = true;
    },

    onConfirm(value)
    {
      this.$emit("changeCargoHoldsNumbs",value);
      this.showPicker = false;
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
